import React from "react";
import { makeStyles } from "tss-react/mui";
import { MiButton } from "@miplatform/components";
import { BUTTON_COLORS } from "@miplatform/constants";
import { mdiChevronLeft, mdiChevronRight } from "@mdi/js";
import { Box } from "@mui/material";

export function ScrollButtons({
  isScrollable,
  visibleStartIndex,
  lastScrollableIndex,
  setVisibleStartIndex,
}: ScrollButtonsProps) {
  const { classes } = useStyles();

  const handleScrollColumn = (direction: "left" | "right") => {
    if (direction === "left") {
      setVisibleStartIndex((prev) => Math.max(0, prev - 1));
    }
    if (direction === "right") {
      setVisibleStartIndex((prev) => Math.min(lastScrollableIndex, prev + 1));
    }
  };

  return (
    <Box
      className={classes.scrollBox}
      sx={{ visibility: isScrollable ? "visible" : "hidden" }}
    >
      <MiButton
        startIcon={{ path: mdiChevronLeft }}
        onClick={() => handleScrollColumn("left")}
        size="small"
        disabled={visibleStartIndex === 0}
        color={BUTTON_COLORS.BLACK}
      />
      <MiButton
        startIcon={{ path: mdiChevronRight }}
        onClick={() => handleScrollColumn("right")}
        size="small"
        disabled={visibleStartIndex >= lastScrollableIndex}
        color={BUTTON_COLORS.BLACK}
      />
    </Box>
  );
}

const useStyles = makeStyles()(() => ({
  scrollBox: {
    display: "flex",
  },
}));

interface ScrollButtonsProps {
  isScrollable: boolean;
  visibleStartIndex: number;
  lastScrollableIndex: number;
  setVisibleStartIndex: React.Dispatch<React.SetStateAction<number>>;
}
